import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountStatus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.6333 10.1667C13.8632 10.1667 14.0837 10.0754 14.2462 9.91284C14.4087 9.75031 14.5 9.52983 14.5 9.29999V6.69997C14.5 6.47013 14.4087 6.24965 14.2462 6.08712C14.0837 5.92459 13.8632 5.8333 13.6333 5.8333M13.6333 10.1667H12.3952C11.8206 10.1667 11.2695 9.93838 10.8631 9.53209C10.4568 9.12573 10.2285 8.57465 10.2285 7.99998C10.2285 7.42532 10.4568 6.87423 10.8631 6.46788C11.2695 6.06158 11.8206 5.8333 12.3952 5.8333H13.6333M13.6333 10.1667L13.6334 11.0333C13.6334 11.493 13.4508 11.9339 13.1257 12.259C12.8007 12.584 12.3598 12.7667 11.9001 12.7667H3.23335C2.77363 12.7667 2.33275 12.584 2.00769 12.259C1.68262 11.9339 1.5 11.493 1.5 11.0333V4.96663C1.5 4.50692 1.68262 4.06603 2.00769 3.74097C2.33275 3.4159 2.7735 3.23328 3.23321 3.23328H11.8999C12.3596 3.23328 12.8007 3.4159 13.1257 3.74097C13.4508 4.06603 13.6334 4.50692 13.6334 4.96663L13.6333 5.8333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.98364 8.1L5.38364 9.5L8.38364 6.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAccountStatus;
